import {
  defaultCategories,
  isGpcEnabled,
  readConsent,
  resolveInitialCategories,
} from "@guru/shared/consent";
import { applyConsent } from "@/lib/posthog-consent";

// Default-denied: PostHog only initialises after explicit consent. GPC forces denial.
const stored = readConsent();
const categories = isGpcEnabled() ? defaultCategories() : resolveInitialCategories(stored);
applyConsent(categories);
